import React, { useEffect, useState } from "react";
import "./PortfolioPage.css";
import Menu from "./Menu";
import Aos from "aos";
import "aos/dist/aos.css";

const PortfolioPage = () => {
  useEffect(() => {
    Aos.init({ duration: 50, once: true, easing: "ease-in-out" });
  }, []);
  const [items, setItems] = useState(Menu);
  const [filteredItems, setFilteredItems] = useState(Menu); // Separate filtered items state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;

  const filterItem = (categoryItem) => {
    // Filter the menu items by category
    const updatedItems = Menu.filter((curElement) => {
      // Ensure both sides are the same case and with no leading/trailing spaces
      return (
        curElement.category.trim().toLowerCase() ===
        categoryItem.trim().toLowerCase()
      );
    });

    // Set filtered items and reset page to 1
    setFilteredItems(updatedItems);
    setCurrentPage(1); // Reset to page 1
  };

  // Calculate the indexes of the current page's items
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <section className="work container section dark:bg-gray-800 dark:text-white" id="work">
      <h2 className="section__title dark:text-white">Recent Works</h2>
      <div className="work__filters">
        <span
          className="work__item "
          onClick={() => {
            setFilteredItems(Menu); 
            setCurrentPage(1);
          }}
        >
          Everything
        </span>
        <span className="work__item" onClick={() => filterItem("Art")}>
          Art
        </span>
        <span className="work__item" onClick={() => filterItem("Design")}>
          Design
        </span>
        <span className="work__item" onClick={() => filterItem("API")}>
          API
        </span>
        <span className="work__item" onClick={() => filterItem("Web")}>
          Web Development
        </span>
      </div>
      <div className="work__container grid">
        {currentItems.map((element) => {
          const { id, image, title, category, link } = element;
          return (
            <div
              className="work__card"
              key={id}
              data-aos="fade-up"
              data-aos-anchor-placement="top-center"
            >
              <div className="work__thumbnail">
                <div className="work__img">
                 <div className="work__mark"></div>
                </div>
                <div
                  className="h-[300px] w-full bg-center bg-cover hover:bg-transparent"
                  style={{ backgroundImage: `url(${image})` }}
                ></div>
                <span className="work__category">{category}</span>
                <h3 className="work__title">{title}</h3>
                <div className="work__button">
                  {/* Wrap the <i> tag with <a> tag for clickable link */}
                  <a href={link} target="_blank" rel="noopener noreferrer">
                    <i className="icon-link work__button-icon"></i>
                  </a>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="pagination">
        {[...Array(totalPages)].map((_, index) => (
          <span
            key={index}
            className={`pagination__item ${
              currentPage === index + 1 ? "active" : ""
            }`}
            onClick={() => paginate(index + 1)}
          >
            {index + 1}
          </span>
        ))}
      </div>
    </section>
  );
};

export default PortfolioPage;
